var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuPlans(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E99233;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.6,295c0-12.8,0-25.4,0-38.1c-4.9,0-9.6,0-14.5,0c0-6,0-12,0-18.2c4.7,0,9.4,0,14.2,0c0-10.2,0-20.2,0-30.4 c-4.7,0-9.4,0-14.2,0c0-6.2,0-12,0-18.4c4.7,0,9.4,0,14.3,0c0-10.5,0-20.5,0-30.8c-4.8,0-9.5,0-14.3,0c0-6.1,0-12,0-18.2 c4.7,0,9.4,0,14.3,0c0-10.2,0-20.1,0-30.4c-4.7,0-9.4,0-14.3,0c0-6.3,0-12.3,0-18.6c4.7,0,9.3,0,14.2,0c0-10.3,0-20.3,0-30.5 c-4.7,0-9.3,0-14.2,0c0-6.1,0-12,0-18.2c4.7,0,9.3,0,14.3,0c0-12.9,0-25.4,0-38.2C115,5,199.4,5,283.9,5c0,96.5,0,193.2,0,290 C199.6,295,115.3,295,30.6,295z M265.4,277c0-84.8,0-169.4,0-254c-72.1,0-144,0-215.9,0c0,6.8,0,13.4,0,20.3c4.9,0,9.7,0,14.4,0 c0,6.1,0,11.9,0,18c-4.9,0-9.7,0-14.3,0c0,10.3,0,20.3,0,30.5c4.9,0,9.6,0,14.3,0c0,6.1,0,11.9,0,18c-4.9,0-9.6,0-14.3,0 c0,10.4,0,20.6,0,31.1c4.9,0,9.7,0,14.4,0c0,6.1,0,11.9,0,18c-4.9,0-9.6,0-14.3,0c0,10.5,0,20.7,0,31.2c4.9,0,9.5,0,14.2,0 c0,6.1,0,11.9,0,17.9c-4.8,0-9.5,0-14.3,0c0,10.3,0,20.3,0,30.6c4.9,0,9.7,0,14.4,0c0,6.1,0,11.9,0,18c-4.9,0-9.6,0-14.4,0 c0,6.9,0,13.6,0,20.2C121.6,277,193.4,277,265.4,277z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.8,79c4.3-4.3,8.4-8.4,12.6-12.6c3.8,4,7.7,8,11.2,11.8c9.4-8.9,18.6-17.8,27.7-26.4c4.1,4,8.4,8,12.6,12.1 c-13.3,12.9-26.6,26-39.7,38.8C106.6,95.2,98.3,87.1,89.8,79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.4,135.3c-13.1,13-26.4,26.1-39.3,39c-8.3-8.1-16.7-16.3-25-24.3c4.2-4.1,8.2-8,12-11.7 c3.9,3.5,8.2,7.2,12.3,10.9c8.8-8.7,17.9-17.7,26.9-26.7C145.8,126.7,150,130.9,154.4,135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142,194.9c3.5,3.5,7.7,7.6,11.8,11.7c-13,12.8-26.2,25.8-39.1,38.6c-7.9-7.8-16.1-16-24.2-23.9 c3.8-3.7,7.9-7.8,12.1-11.9c3.6,3.5,7.7,7.6,11.3,11.2C123.5,212,132.8,203.4,142,194.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.5,88.9c-18.7,0-37.2,0-55.8,0c0-5.9,0-11.7,0-17.8c18.5,0,37.1,0,55.8,0C235.5,77,235.5,82.8,235.5,88.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.5,141.1c0,5.9,0,11.7,0,17.7c-18.6,0-37.1,0-55.8,0c0-5.8,0-11.6,0-17.7 C198.2,141.1,216.8,141.1,235.5,141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5,234.6c0-6,0-11.7,0-17.8c1.1,0,2.1,0,3.1,0c16.5,0,33,0.1,49.4-0.1c2.9,0,3.7,0.9,3.6,3.7 c-0.2,4.7-0.1,9.4-0.1,14.2C216.8,234.6,198.3,234.6,179.5,234.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuPlans);
export default __webpack_public_path__ + "static/media/icon-menu-plans.d845003c8caedbd5262cdcb00651cea4.svg";
export { ForwardRef as ReactComponent };